import React from 'react';

const SuspenseLoader = () => {
    return <div className={"loadingWrapper"}>
        <div id="loading"/>
    </div>;
}

export default SuspenseLoader;